// extracted by mini-css-extract-plugin
module.exports = {"container":"Arrows_container__3j_g8","arrow":"Arrows_arrow__1MZDE"};